import logoImg from "@assets/imgs/logo.png";
import { Space } from "@components/Space";
import { JsonLdScript } from "@features/ceo/components/JsonLdScript";
import { halalShopOrganizationLdConfig } from "@features/ceo/configs/halalShopOrganizationLdConfig";
import { SeasonalProductsSectionAdapter } from "@features/products/components/SeasonalProductsSectionAdapter";
import { paths } from "@features/routering/paths";
import { withDomainPath } from "@features/routering/withDomainPath";
import { AdvantagesCards } from "@features/sections/components/AdvantagesCards";
import { MainLayout } from "@layouts/MainLayout";
import withAuthSSG from "@features/ssr/hoc/withAuth";
import { Breadcrumbs } from "@packages/uiKit/BreadCrumbs";
import Head from "next/head";
import { FC } from "react";
import { AdvantagesStats } from "./AdvantagesStats";
import { ArticlesAndCompanyNewsSection } from "./ArticlesAndCompanyNewsSection";
import { Banner } from "./Banner";
import { MissionValues } from "./MissionValues";
import { breadCrumbsAboutPage } from "./constants";
import { useTranslations } from "next-intl";
import { getBreadcrumbsTranslations } from "@packages/uiKit/BreadCrumbs/utils/getBreadcrumbsTranslations";

export const AboutPage: FC = withAuthSSG(() => {
  const t = useTranslations("AboutUsPage");

  const breadCrumbsTranslated = getBreadcrumbsTranslations(
    breadCrumbsAboutPage,
    [t("Breadcrumbs.label_0"), t("Breadcrumbs.label_1")]
  );

  return (
    <MainLayout showSeparator>
      <Head>
        <link rel="canonical" href={withDomainPath(paths.about())} />
        <JsonLdScript json={halalShopOrganizationLdConfig} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Интернет-магазин Halal Shop" />
        <meta property="og:description" content="Описание" />
        <meta property="og:image" content={withDomainPath(logoImg.src)} />
        <meta property="og:site_name" content="Halal Shop" />
      </Head>
      <MainLayout.Content paddingBottom="none">
        <Breadcrumbs items={breadCrumbsTranslated} />
        <Banner />
        <Space size={100} mobile={50} tablet={60} />
        <AdvantagesStats />
        <Space size={120} mobile={50} tablet={60} />
        <MissionValues />
        <Space size={120} mobile={50} tablet={60} />
        <ArticlesAndCompanyNewsSection />
        <Space size={120} mobile={50} tablet={60} />
        <SeasonalProductsSectionAdapter />
        <AdvantagesCards />
      </MainLayout.Content>
    </MainLayout>
  );
});
